export enum DonationServiceType {
  CHARITY = 1,
  CAMPAIGN = 2,
  // ORPHAN = 3
}

export const getDonationServiceType = (status: DonationServiceType) => {
  switch (status) {
    case DonationServiceType.CHARITY:
      return "charity";
    case DonationServiceType.CAMPAIGN:
      return "campaign";
    // case DonationServiceType.ORPHAN:
    //   return "orphan";
    default:
      return "";
  }
};

export const getDonationServiceTypeByNumBer = (status: Number) => {
  switch (status) {
    case 1:
      return "charity";
    case 2:
      return "campaign";
    // case 3:
    //   return "orphan";
    default:
      return "";
  }
};
